import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/store';
// import './registerServiceWorker';
import 'vuetify/dist/vuetify.min.css';
import '@/assets/css/tailwind.css';
import '@/assets/css/balloon.min.css';
import '@/assets/scss/daizy.scss';
import '@/helpers/filters';
import '@mdi/font/css/materialdesignicons.min.css';
import '@mdi/font/fonts/materialdesignicons-webfont.ttf';
import '@mdi/font/fonts/materialdesignicons-webfont.eot';
import '@mdi/font/fonts/materialdesignicons-webfont.woff';
import '@mdi/font/fonts/materialdesignicons-webfont.woff2';
import 'typeface-roboto';
import Sidebar from './components/Sidebar.vue';
import Navigation from './components/Navigation.vue';
import Checkbox from './components/Checkbox.vue';
import DropDown from './components/DropDown.vue';
import Menu from './components/Menu.vue';
import Button from './components/Button.vue';
import Breadcrumb from './components/Breadcrumb.vue';
import Badge from './components/Badge.vue';
import vuetify from '@/plugins/vuetify';
import axios from 'axios';

if (navigator.serviceWorker) {
  navigator.serviceWorker.getRegistrations().then(
    (registrations) => {
      registrations.map((r) => r.unregister());
  });
}

Vue.config.productionTip = false;
Vue.config.errorHandler = (err, vm, info) => {
  if (!axios.isCancel(err)) {
    // tslint:disable-next-line
    console.error(err, [vm, info]);
    store.dispatch('addToastErrorMessage', err.message);
  }
};

// Register global components
Vue.component('Sidebar', Sidebar);
Vue.component('Navigation', Navigation);
Vue.component('Checkbox', Checkbox);
Vue.component('DropDown', DropDown);
Vue.component('Menu', Menu);
Vue.component('Button', Button);
Vue.component('Breadcrumb', Breadcrumb);
Vue.component('Badge', Badge);

// Listen for messages in order to display toast errors from allowed iframes.
window.addEventListener('message', (event: any) => {
  const allowedOrigins = ['https://waterhealth.daizy.io', 'https://waterhealth-test.daizy.io', 'https://wavetrend.daizy.io'];
  if (event.data === 401) {
    if (event.origin.includes('localhost')) {
      store.dispatch('addToastErrorMessage', 'Could not authenticate the application. Please use a valid Daizy token.');
    } else if (allowedOrigins.includes(event.origin)) {
      store.dispatch('addToastErrorMessage', 'Could not authenticate the application. Please use a valid Daizy token.');
    }
  }
}, false);

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
